import {Component} from 'react';
import axios from "axios"
import Nav from "../../Componet/Nav";
import Swal from "sweetalert2";
import myconfig from "../../myconfig";
import {Modal} from "react-bootstrap";

let source = axios.CancelToken.source();

class Allocate_allocate_vehicle_v3 extends Component {
    constructor() {
        super();
        this.state = {
            vehs: [],
            vehsorginal: null,
            vehsorginall: false,
            txtsearch: '',

            fright: false,
            frightno: "",
            assignment: null,

            openorder: false,
            openordersorginal: null,
            openordersorginall: false,
            orders: [],
            txtsearch_order: '',
            allocation_id: '',

            assignshow: false,
            wizard: 0,

            cushow2: false,
            cushow2type:'',
            actfuelqtyempty_now:'',
            actfuelqtyload_now:'',
            actprediemempty_now:'',
            actpredieload_now:'',
            acthandlefeeempty_now:'',
            acthandlefeeload_now:'',
            fuelqtyempty_now:'',
            fuelqtyload_now:'',
            prediemempty_now:'',
            predieload_now:'',
            handlefeeempty_now:'',
            handlefeeload_now:'',
            remark_now:'',

            actfuelqtyempty_next:'',
            actfuelqtyload_next:'',
            actprediemempty_next:'',
            actpredieload_next:'',
            acthandlefeeempty_next:'',
            acthandlefeeload_next:'',
            fuelqtyempty_next:'',
            fuelqtyload_next:'',
            prediemempty_next:'',
            predieload_next:'',
            handlefeeempty_next:'',
            handlefeeload_next:'',
            remark_next:'',

            fright2:false,
            frightno2: "",
            order_type: "",
            order_id_1:"",
            order_id_2:"",
            isnext:false,
        }
    }

    async componentDidMount() {
        this.get_vehicle_for_allocation_v3();
    }
    inputmgt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
    }
    inputmgt_fitler = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
        if (this.state.vehsorginall) {
            let temp = this.state.vehsorginal.datas;
            if (value != "") {
                temp = temp.filter(v => {
                    if (v.plate_no.toUpperCase().includes(value.toUpperCase())) {
                        return value;
                    }
                })
            }
            this.setState({
                vehs: temp,
            })
        }
    }
    get_vehicle_for_allocation_v3 = () => {
        let baseurl = myconfig.get_vehicle_for_allocation_v3;
        let redirecttologin = myconfig.redirecttologin;
        this.setState({
            vehs: [],
            vehsorginal: null,
            vehsorginall: false,
            txtsearch: '',

            fright: false,
            frightno: "",
            assignment: null,

            openorder: false,
            openordersorginal: null,
            openordersorginall: false,
            orders: [],
            txtsearch_order: '',
            allocation_id: '',

            assignshow: false,
            wizard: 0,

            cushow2: false,
            cushow2type:'',
            actfuelqtyempty_now:'',
            actfuelqtyload_now:'',
            actprediemempty_now:'',
            actpredieload_now:'',
            acthandlefeeempty_now:'',
            acthandlefeeload_now:'',
            fuelqtyempty_now:'',
            fuelqtyload_now:'',
            prediemempty_now:'',
            predieload_now:'',
            handlefeeempty_now:'',
            handlefeeload_now:'',
            remark_now:'',

            actfuelqtyempty_next:'',
            actfuelqtyload_next:'',
            actprediemempty_next:'',
            actpredieload_next:'',
            acthandlefeeempty_next:'',
            acthandlefeeload_next:'',
            fuelqtyempty_next:'',
            fuelqtyload_next:'',
            prediemempty_next:'',
            predieload_next:'',
            handlefeeempty_next:'',
            handlefeeload_next:'',
            remark_next:'',

            fright2:false,
            frightno2: "",
            order_type: "",
            order_id_1:"",
            order_id_2:"",
            isnext:false,
        })
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
            order_id: this.state.order_id,
        }, {cancelToken: source.token}).then(res => {
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    vehs: res.data.datas,
                    vehsorginal: res.data,
                    vehsorginall: true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }

    modalfright2 = () => {
        return (<Modal
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.fright2}
                onHide={this.hidefright2}>
                <Modal.Header><h4>Fright # Next</h4></Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-primary">
                                <div className="card-header">
                                    <h3 className="card-title">Fright Management</h3>
                                </div>
                                <form>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Fright #</label>
                                                    <input className="form-control" type="text" name="frightno2"
                                                           onChange={this.inputmgt} value={this.state.frightno2}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-footer">
                                        <button type="submit" className="btn btn-primary"
                                                onClick={this.submitfright2}>Next
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
    hidefright2 = () => {
        this.setState({
            fright2: false,
        })
    }
    submitfright2 = (event) => {
        event.preventDefault()
        let baseurl = myconfig.check_fright_no_v2;
        let redirecttologin = myconfig.redirecttologin;
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
            frightno: this.state.frightno,
            frightno2: this.state.frightno2,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.showopenorder(2);
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }

    modalfright = () => {
        return (<Modal
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.fright}
                onHide={this.hidefright}>
                <Modal.Header><h4>Fright #</h4></Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-primary">
                                <div className="card-header">
                                    <h3 className="card-title">Fright Management</h3>
                                </div>
                                <form>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Fright #</label>
                                                    <input className="form-control" type="text" name="frightno"
                                                           onChange={this.inputmgt} value={this.state.frightno}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-footer">
                                        <button type="submit" className="btn btn-primary"
                                                onClick={this.submitfright}>Next
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
    showfright = (event, assignment) => {
        event.preventDefault()
        this.setState({
            fright: true,
            fright_no: '',
            assignment: assignment,
        })
    }
    hidefright = () => {
        this.setState({
            fright: false,
        })
    }
    submitfright = (event) => {
        event.preventDefault()
        let baseurl = myconfig.check_fright_no;
        let redirecttologin = myconfig.redirecttologin;
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
            fright_no: this.state.frightno,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.showopenorder(1);
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }

    modalopenorder = () => {
        return (<Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.openorder}
                onHide={this.hideopenorder}>
                <Modal.Header><h4>Open Order's</h4></Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="card-tools">
                                        <div className="input-group input-group-sm" style={{width: '150px'}}>
                                            <input type="text" name="txtsearch_order"
                                                   onChange={this.inputmgt_fitler_openorder}
                                                   className="form-control float-right"
                                                   value={this.state.txtsearch_order} placeholder="Search"/>
                                            <div className="input-group-append">
                                                <button type="submit" className="btn btn-default">
                                                    <i className="fas fa-search"/>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body table-responsive p-0" style={{height: '500px'}}>
                                    <table className="table table-head-fixed text-nowrap">
                                        <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Action</th>
                                            <th>Order Date</th>
                                            <th>Order #</th>
                                            <th>Company Name</th>
                                            <th>Cargo Name</th>
                                            <th>Volume</th>
                                            <th>Sale Type</th>
                                            <th>Type</th>
                                            <th>Transport Rate</th>
                                            <th>Cement Rate</th>
                                            <th>Cement Cost</th>
                                            <th>Start Date</th>
                                            <th>Closed Date</th>
                                            <th>Org</th>
                                            <th>Des</th>
                                            <th>Total</th>
                                            <th>Assigned</th>
                                            <th>Not-assigned</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.tabledataopenorder()}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
    showopenorder = (order_type) => {
        this.setState({
            openordersorginal: null,
            openordersorginall: false,
            orders: [],
            openorder: false,
            order_type: order_type,
        })
        let baseurl = myconfig.get_open_order_status_for_allocation;
        let redirecttologin = myconfig.redirecttologin;
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    openordersorginal: res.data,
                    openordersorginall: true,
                    orders: res.data.datas,
                    openorder: true,
                    fright: false,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });

    }
    hideopenorder = () => {
        this.setState({
            openorder: false,
        })
    }
    submitopenorder = (event, order_id) => {
        event.preventDefault()
        if(this.state.order_type==1){
            let baseurl = myconfig.get_allocation_id_for;
            let redirecttologin = myconfig.redirecttologin;
            axios.post(baseurl, {
                sid: window.localStorage.getItem("ntfms_sid"),
                order_id: order_id,
            }, {cancelToken: source.token}).then(res => {
                console.log(res.data)
                if (res.data.auth == false) {
                    window.localStorage.setItem("ntfms_sid", null);
                    window.localStorage.setItem("ntfms_username", null);
                    window.localStorage.setItem("ntfms_name", null);
                    var win = window.open(redirecttologin, "_self");
                } else if (res.data.success == false) {
                    Swal.fire({
                        title: 'Error!',
                        text: res.data.msg,
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                } else {
                    if (res.data.allocation_id == null) {
                        Swal.fire({
                            title: 'Error!',
                            text: "No allocation found for vehicle to be allocated",
                            icon: 'error',
                            confirmButtonText: 'Okay'
                        })
                    } else {
                        this.setState({
                            allocation_id: res.data.allocation_id,
                            openorder: false,
                            cushow2type:1,
                            order_id_1:order_id,
                        },()=>this.showcu2())
                        //() => this.wizard_1_btn()
                    }
                }
            }).catch((e) => {
                console.log(e.message);
            });
        }
        else
        {
            let baseurl = myconfig.get_route_information;
            let redirecttologin = myconfig.redirecttologin;
            axios.post(baseurl, {
                sid: window.localStorage.getItem("ntfms_sid"),
                order_id_1: this.state.order_id_1,
                order_id_2: order_id,
            }, {cancelToken: source.token}).then(res => {
                console.log(res.data)
                if (res.data.auth == false) {
                    window.localStorage.setItem("ntfms_sid", null);
                    window.localStorage.setItem("ntfms_username", null);
                    window.localStorage.setItem("ntfms_name", null);
                    var win = window.open(redirecttologin, "_self");
                } else if (res.data.success == false) {
                    Swal.fire({
                        title: 'Error!',
                        text: res.data.msg,
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                } else {
                    this.setState({
                        actfuelqtyempty_next: res.data.actfuelqtyempty_next,
                        actfuelqtyload_next: res.data.actfuelqtyload_next,
                        actprediemempty_next: res.data.actprediemempty_next,
                        actpredieload_next: res.data.actpredieload_next,
                        acthandlefeeempty_next: res.data.acthandlefeeempty_next,
                        acthandlefeeload_next: res.data.acthandlefeeload_next,
                        fuelqtyempty_next: res.data.actfuelqtyempty_next,
                        fuelqtyload_next: res.data.actfuelqtyload_next,
                        prediemempty_next: res.data.actprediemempty_next,
                        predieload_next: res.data.actpredieload_next,
                        handlefeeempty_next: res.data.acthandlefeeempty_next,
                        handlefeeload_next: res.data.acthandlefeeload_next,
                        cushow2: true,
                        cushow2type:'2',
                        order_id_2: order_id,
                    })
                }
            }).catch((e) => {
                console.log(e.message);
            });
        }

    }
    inputmgt_fitler_openorder = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
        if (this.state.openordersorginall) {
            let temp = this.state.openordersorginal.datas;
            if (value != "") {
                temp = temp.filter(v => {
                    if (v.companyname.toUpperCase().includes(value.toUpperCase())) {
                        return value;
                    }
                })
            }
            this.setState({
                orders: temp,
            })
        }
    }
    tabledataopenorder = () => {
        let count = 0;
        let retdata = this.state.orders.map(value => {
            count = count + 1
            return (<tr>
                <td>{count}</td>
                <td><a href="{#}" onClick={(event => this.submitopenorder(event, value.id))}>Select</a>
                </td>
                <td>{value.orderdate}</td>
                <td>{value.order_no}</td>
                <td>{value.companyname}</td>
                <td>{value.cargo_name}</td>
                <td>{value.volume}</td>
                <td>{value.sale_type}</td>
                <td>{value.type}</td>
                <td>{value.transport_rate_q}</td>
                <td>{value.cement_rate_q}</td>
                <td>{value.cement_cost}</td>
                <td>{value.stdate}</td>
                <td>{value.eddate}</td>
                <td>{value.rr_loc_org}</td>
                <td>{value.rr_loc_des}</td>
                <td>{value.total_count}</td>
                <td>{value.assigned_count}</td>
                <td>{value.not_assigned}</td>
            </tr>)
        })
        return (<>{retdata}</>)
    }

    hideassign = () => {
        this.setState({
            assignshow: false,
        })
    }
    modalassign = () => {
        let display = null;
        let size = "md";
        if (this.state.wizard == 2)
            display = this.wizard_2()
        else if (this.state.wizard == 3)
            display = this.wizard_3()
        else if (this.state.wizard == 4)
            display = this.wizard_4()
        return (<Modal
                size={size}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.assignshow}
                onHide={this.hideassign}>
                <Modal.Header><h4>Vehicle Assigment</h4>
                    <small>({this.state.msg})</small></Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12">
                            {display}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
    execute_waiting_for_order = () => {
        let baseurl = myconfig.vehicle_allocation_v3;
        let redirecttologin = myconfig.redirecttologin;
        axios.post(baseurl, {
            "sid": window.localStorage.getItem("ntfms_sid"),
            "allocation_id": this.state.allocation_id,
            "assignment_id": this.state.assignment.id,
            "frightno": this.state.frightno,
            "wiz_algo": 1,
            "actfuelqtyempty_now": this.state.actfuelqtyempty_now,
            "actfuelqtyload_now": this.state.actfuelqtyload_now,
            "actprediemempty_now": this.state.actprediemempty_now,
            "actpredieload_now": this.state.actpredieload_now,
            "acthandlefeeempty_now": this.state.acthandlefeeempty_now,
            "acthandlefeeload_now": this.state.acthandlefeeload_now,
            "fuelqtyempty_now": this.state.fuelqtyempty_now,
            "fuelqtyload_now": this.state.fuelqtyload_now,
            "prediemempty_now": this.state.prediemempty_now,
            "predieload_now": this.state.predieload_now,
            "handlefeeempty_now": this.state.handlefeeempty_now,
            "handlefeeload_now": this.state.handlefeeload_now,
            "remark_now": this.state.remark_now,
            "actfuelqtyempty_next": this.state.actfuelqtyempty_next,
            "actfuelqtyload_next": this.state.actfuelqtyload_next,
            "actprediemempty_next": this.state.actprediemempty_next,
            "actpredieload_next": this.state.actpredieload_next,
            "acthandlefeeempty_next": this.state.acthandlefeeempty_next,
            "acthandlefeeload_next": this.state.acthandlefeeload_next,
            "fuelqtyempty_next": this.state.fuelqtyempty_next,
            "fuelqtyload_next": this.state.fuelqtyload_next,
            "prediemempty_next": this.state.prediemempty_next,
            "predieload_next": this.state.predieload_next,
            "handlefeeempty_next": this.state.handlefeeempty_next,
            "handlefeeload_next": this.state.handlefeeload_next,
            "remark_next": this.state.remark_next,
            "frightno2": this.state.frightno2,
            "order_id_1": this.state.order_id_1,
            "order_id_2": this.state.order_id_2,
            "isnext": this.state.isnext,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                Swal.fire({
                    title: 'Success!',
                    text: "Vehicle select successfully",
                    icon: 'success',
                    confirmButtonText: 'Okay'
                }).then(value => {
                    this.get_vehicle_for_allocation_v3()
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });

    }

    wizard_1_btn = () => {
        console.log(this.state.assignment)
        if (this.state.assignment.status == "WAITING_FOR_ORDER") {
            Swal.fire({
                title: 'Do you need to add others fright order?',
                showDenyButton: true,
                confirmButtonText: 'Yes',
                denyButtonText: 'No',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.setState({
                        fright2: true,
                    })
                }
                else if (result.isDenied) {
                    Swal.fire({
                        title: 'Are you sure?',
                        showDenyButton: true,
                        confirmButtonText: 'Yes',
                        denyButtonText: 'No',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.setState({
                                isnext: false,
                            },()=>this.execute_waiting_for_order())
                        } else if (result.isDenied) {
                            this.setState({
                                fright2: true,
                            })
                        }
                    })
                }
            })
        }
    }

    assignvehicle = (event, id) => {
        event.preventDefault()
        let baseurl = myconfig.getavavehicles;
        let sid = new URLSearchParams(this.props.location.search).get("sid");
        let user = new URLSearchParams(this.props.location.search).get("user");
        axios.post(baseurl, {
            "sid": sid,
            "user": user,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    vehicles: res.data.datas,
                    vehicleload: true,
                    assignshow: true,
                    wizard: 1,
                    allocation_id: id,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }

    showcu2 = () => {
        if (this.state.cushow2type == 1) {
            let baseurl = myconfig.get_cost_for_now;
            let redirecttologin = myconfig.redirecttologin;
            axios.post(baseurl, {
                sid: window.localStorage.getItem("ntfms_sid"),
                allocation_id: this.state.allocation_id,
            }, {cancelToken: source.token}).then(res => {
                console.log(res.data)
                if (res.data.auth == false) {
                    window.localStorage.setItem("ntfms_sid", null);
                    window.localStorage.setItem("ntfms_username", null);
                    window.localStorage.setItem("ntfms_name", null);
                    var win = window.open(redirecttologin, "_self");
                } else if (res.data.success == false) {
                    Swal.fire({
                        title: 'Error!',
                        text: res.data.msg,
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                } else {
                    this.setState({
                        cushow2: true,
                        actfuelqtyempty_now: res.data.actfuelqtyempty_now,
                        actfuelqtyload_now: res.data.actfuelqtyload_now,
                        actprediemempty_now: res.data.actprediemempty_now,
                        actpredieload_now: res.data.actpredieload_now,
                        acthandlefeeempty_now: res.data.acthandlefeeempty_now,
                        acthandlefeeload_now: res.data.acthandlefeeload_now,
                        fuelqtyempty_now: res.data.actfuelqtyempty_now,
                        fuelqtyload_now: res.data.actfuelqtyload_now,
                        prediemempty_now: res.data.actprediemempty_now,
                        predieload_now: res.data.actpredieload_now,
                        handlefeeempty_now: res.data.acthandlefeeempty_now,
                        handlefeeload_now: res.data.acthandlefeeload_now,
                    })
                }
            }).catch((e) => {
                console.log(e.message);
            });
        } else if (this.state.cushow2type == 2) {

        }
    }
    hidecu2 = () => {
        this.setState({
            cushow2: false,
        })
    }
    modalcu2 = () => {
        let display = null
        if (this.state.cushow2type == "1")
            display = this.modal_cost_now()
        else if (this.state.cushow2type == "2")
            display = this.modal_cost_next()
        else
            display=<h1>I am here</h1>
        return (<>
                <Modal
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.cushow2}
                    onHide={this.hidecu2}>
                    <Modal.Header><h4>Cost Request & Approval</h4></Modal.Header>
                    <Modal.Body>
                        {display}
                    </Modal.Body>
                </Modal>
            </>
        )
    }
    modal_cost_now=()=> {
        return (
            <div className="row">
                <div className="col-md-6">
                    <div className="card card-primary">
                        <div className="card-header">
                            <h3 className="card-title">Actual Data</h3>
                        </div>
                        <form>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Fuel Qty Empty</label>
                                            <input disabled={true} className="form-control" type="text"
                                                   name="actfuelqtyempty_now" onChange={this.inputmgt}
                                                   value={this.state.actfuelqtyempty_now}/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Fuel Qty Loaded</label>
                                            <input disabled={true} className="form-control" type="text"
                                                   name="actfuelqtyload_now" onChange={this.inputmgt}
                                                   value={this.state.actfuelqtyload_now}/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Per Diem Empty</label>
                                            <input disabled={true} className="form-control" type="text"
                                                   name="actprediemempty_now" onChange={this.inputmgt}
                                                   value={this.state.actprediemempty_now}/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Per Diem Loaded</label>
                                            <input disabled={true} className="form-control" type="text"
                                                   name="actpredieload_now" onChange={this.inputmgt}
                                                   value={this.state.actpredieload_now}/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Handling Fee Empty</label>
                                            <input disabled={true} className="form-control" type="text"
                                                   name="acthandlefeeempty_now" onChange={this.inputmgt}
                                                   value={this.state.acthandlefeeempty_now}/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Handling Fee Loaded</label>
                                            <input disabled={true} className="form-control" type="text"
                                                   name="acthandlefeeload_now" onChange={this.inputmgt}
                                                   value={this.state.acthandlefeeload_now}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="card card-primary">
                        <div className="card-header">
                            <h3 className="card-title">Request Data</h3>
                        </div>
                        <form>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Fuel Qty Empty</label>
                                            <input className="form-control" type="text" name="fuelqtyempty_now"
                                                   onChange={this.inputmgt} value={this.state.fuelqtyempty_now}/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Fuel Qty Loaded</label>
                                            <input className="form-control" type="text" name="fuelqtyload_now"
                                                   onChange={this.inputmgt} value={this.state.fuelqtyload_now}/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Per Diem Empty</label>
                                            <input className="form-control" type="text" name="prediemempty_now"
                                                   onChange={this.inputmgt} value={this.state.prediemempty_now}/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Per Diem Loaded</label>
                                            <input className="form-control" type="text" name="predieload_now"
                                                   onChange={this.inputmgt} value={this.state.predieload_now}/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Handling Fee Empty</label>
                                            <input className="form-control" type="text" name="handlefeeempty_now"
                                                   onChange={this.inputmgt} value={this.state.handlefeeempty_now}/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Handling Fee Loaded</label>
                                            <input className="form-control" type="text" name="handlefeeload_now"
                                                   onChange={this.inputmgt} value={this.state.handlefeeload_now}/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Remark</label>
                                            <input className="form-control" type="text" name="remark_now"
                                                   onChange={this.inputmgt} value={this.state.remark_now}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer">
                                <button type="submit" className="btn btn-primary"
                                        onClick={this.submitcu2}>Next
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        )
    }
    modal_cost_next=()=> {
        return (
            <div className="row">
                <div className="col-md-6">
                    <div className="card card-primary">
                        <div className="card-header">
                            <h3 className="card-title">Actual Data</h3>
                        </div>
                        <form>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Fuel Qty Empty</label>
                                            <input disabled={true} className="form-control" type="text"
                                                   name="actfuelqtyempty_next" onChange={this.inputmgt}
                                                   value={this.state.actfuelqtyempty_next}/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Fuel Qty Loaded</label>
                                            <input disabled={true} className="form-control" type="text"
                                                   name="actfuelqtyload_next" onChange={this.inputmgt}
                                                   value={this.state.actfuelqtyload_next}/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Per Diem Empty</label>
                                            <input disabled={true} className="form-control" type="text"
                                                   name="actprediemempty_next" onChange={this.inputmgt}
                                                   value={this.state.actprediemempty_next}/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Per Diem Loaded</label>
                                            <input disabled={true} className="form-control" type="text"
                                                   name="actpredieload_next" onChange={this.inputmgt}
                                                   value={this.state.actpredieload_next}/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Handling Fee Empty</label>
                                            <input disabled={true} className="form-control" type="text"
                                                   name="acthandlefeeempty_next" onChange={this.inputmgt}
                                                   value={this.state.acthandlefeeempty_next}/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Handling Fee Loaded</label>
                                            <input disabled={true} className="form-control" type="text"
                                                   name="acthandlefeeload_next" onChange={this.inputmgt}
                                                   value={this.state.acthandlefeeload_next}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="card card-primary">
                        <div className="card-header">
                            <h3 className="card-title">Request Data</h3>
                        </div>
                        <form>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Fuel Qty Empty</label>
                                            <input className="form-control" type="text" name="fuelqtyempty_next"
                                                   onChange={this.inputmgt} value={this.state.fuelqtyempty_next}/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Fuel Qty Loaded</label>
                                            <input className="form-control" type="text" name="fuelqtyload_next"
                                                   onChange={this.inputmgt} value={this.state.fuelqtyload_next}/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Per Diem Empty</label>
                                            <input className="form-control" type="text" name="prediemempty_next"
                                                   onChange={this.inputmgt} value={this.state.prediemempty_next}/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Per Diem Loaded</label>
                                            <input className="form-control" type="text" name="predieload_next"
                                                   onChange={this.inputmgt} value={this.state.predieload_next}/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Handling Fee Empty</label>
                                            <input className="form-control" type="text" name="handlefeeempty_next"
                                                   onChange={this.inputmgt} value={this.state.handlefeeempty_next}/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Handling Fee Loaded</label>
                                            <input className="form-control" type="text" name="handlefeeload_next"
                                                   onChange={this.inputmgt} value={this.state.handlefeeload_next}/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Remark</label>
                                            <input className="form-control" type="text" name="remark_next"
                                                   onChange={this.inputmgt} value={this.state.remark_next}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer">
                                <button type="submit" className="btn btn-primary"
                                        onClick={this.submitcu3}>Request
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
    submitcu2 = (event) => {
        event.preventDefault()
        let baseurl = myconfig.check_cost_values;
        let redirecttologin = myconfig.redirecttologin;
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
            fuelqtyempty: this.state.fuelqtyempty_now,
            prediemempty: this.state.fuelqtyload_now,
            handlefeeempty: this.state.prediemempty_now,
            fuelqtyload: this.state.predieload_now,
            predieload: this.state.handlefeeempty_now,
            handlefeeload: this.state.handlefeeload_now,
            req_remark: this.state.remark_now,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    cushow2: false,
                }, () => this.wizard_1_btn())
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    submitcu3 = (event) => {
        event.preventDefault()
        this.setState({
            isnext: true,
        },()=>this.execute_waiting_for_order())
    }

    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }

    tabledata = () => {
        let count = 0;
        let retdata = this.state.vehs.map(value => {
            count = count + 1
            return (<tr>
                <td>{count}</td>
                <td>
                    <a href="#" onClick={(event) => this.showfright(event, value)}>Assign</a>
                </td>
                <td>{value.plate_no}</td>
                <td>{value.status}</td>
                <td>{value.dri_name}</td>
                <td>{value.dri_phoneno}</td>
                <td>{value.tra_plateno}</td>
                <td>{value.orderdate}</td>
                <td>{value.volume}</td>
                <td>{value.sale_type}</td>
                <td>{value.org}</td>
                <td>{value.des}</td>
                <td>{value.cargo_id}</td>
                <td>{value.customer_id}</td>
                <td>{value.dateofoffloading}</td>
            </tr>)
        })
        return (<>{retdata}</>)
    }

    render() {
        return (
            <>
                <Nav type="allocate_allocate_vehicle_v3"/>
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Allocation V3</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href={this.state.urlorder}>Allocation V3</a>
                                        </li>
                                        <li className="breadcrumb-item active"></li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="card-tools">
                                            <div className="input-group input-group-sm" style={{width: '150px'}}>
                                                <input type="text" name="txtsearch" onChange={this.inputmgt_fitler}
                                                       className="form-control float-right" placeholder="Search"/>
                                                <div className="input-group-append">
                                                    <button type="submit" className="btn btn-default">
                                                        <i className="fas fa-search"/>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body table-responsive p-0" style={{height: '500px'}}>
                                        <table className="table table-head-fixed text-nowrap">
                                            <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Action</th>
                                                <th>Truck</th>
                                                <th>Status</th>
                                                <th>Driver</th>
                                                <th>Contact</th>
                                                <th>Trailer</th>
                                                <th>(prv) Order Date</th>
                                                <th>(prv) Volume</th>
                                                <th>(prv) Sale_type</th>
                                                <th>(prv) Org</th>
                                                <th>(prv) Des</th>
                                                <th>(prv) Cargo</th>
                                                <th>(prv) Customer</th>
                                                <th>(prv) Offloading</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {this.tabledata()}
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* /.card-body */}
                                </div>
                                {/* /.card */}
                            </div>
                        </div>
                    </section>
                </div>
                {this.modalfright()}
                {this.modalopenorder()}
                {this.modalassign()}
                {this.modalcu2()}
                {this.modalfright2()}
            </>
        )
    }
}

export default Allocate_allocate_vehicle_v3;
